import { Select, Typography, Spin } from 'antd';
import type { DefaultOptionType } from 'rc-select/lib/Select';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAPIAuditReports } from 'services/api/Endorsers';
import { FacilitySelectProps } from './typings';
import styles from './index.module.less';

const FacilitySelect = ({
  auditSearch: search,
  setSearch,
  auditReportsParams,
  setAuditReportsParams,
}: FacilitySelectProps) => {
  const [facilityList, setFacilityList] = useState<string>();
  const { t } = useTranslation('pages', {
    keyPrefix: 'endorsers_partners.view_company.tables_container',
  });
  const { data, isLoading } = useAPIAuditReports({
    bapNumber: auditReportsParams.bapNumber,
    pageSize: auditReportsParams.pageSize,
    pageNumber: Number(auditReportsParams.pageNumber),
  });

  const removeDuplicates = (value: any, index: any, self: any) =>
    index ===
    self.findIndex(
      (val: any) => val.facilityName === value.facilityName && val.bapNumber === value.bapNumber,
    );

  // we create here the list with the shape the select is expecting for
  const selectOptions: Array<DefaultOptionType> =
    data?.results?.filter(removeDuplicates).map((item: any) => ({
      label: String(item.facilityName).concat(` - ${item.bapNumber}`),
      value: String(item.facilityName).concat(` - ${item.bapNumber}`),
    })) || [];

  useEffect(() => {
    if (search.facilityName === '') {
      setFacilityList(undefined);
    }
  }, [search]);

  const onFacilityChange = (e: any, record: any) => {
    setFacilityList(e);
    setAuditReportsParams({
      ...auditReportsParams,
      pageNumber: 1,
    });

    if (record?.label) {
      const arr = record.label.split(' - ');
      setSearch({ ...search, facilityName: arr[0], bapNumber: arr[1] });
    }
  };

  const onClearButtonClick = () => {
    setSearch({ ...search, facilityName: '', bapNumber: '' });
  };

  return (
    <Select
      size="middle"
      options={selectOptions}
      className={styles.container}
      notFoundContent={isLoading ? <Spin size="small" /> : null}
      placeholder={
        <Typography.Text style={{ opacity: '0.3', fontWeight: '400' }}>
          {t('facility_select_placeholder')}
        </Typography.Text>
      }
      allowClear
      showSearch
      value={facilityList}
      onChange={onFacilityChange}
      onClear={onClearButtonClick}
    />
  );
};

export default FacilitySelect;
